// extracted by mini-css-extract-plugin
export default {"loader":"AutoAssignProductsModal_loader__0peL+","nopreview":"AutoAssignProductsModal_nopreview__rvhZC"};